import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';
import axios from 'axios';

export const CREATE_CREDITNOTES_REQUEST = 'CREATE_CREDITNOTES_REQUEST';
export const CREATE_CREDITNOTES_SUCCESS = 'CREATE_CREDITNOTES_SUCCESS';
export const CREATE_CREDITENOTES_ERROR = 'CREATE_CREDITENOTES_ERROR';

export const FETCH_CREDITNOTE_REQUEST = 'FETCH_CREDITNOTE_REQUEST';
export const FETCH_CREDITNOTE_SUCCESS = 'FETCH_CREDITNOTE_SUCCESS';
export const FETCH_CREDITNOTE_ERROR = 'FETCH_CREDITNOTE_ERROR';

export const GET_CREDIT_NOTE_DETAIL_REQUEST = 'GET_CREDIT_NOTE_DETAIL_REQUEST';
export const GET_CREDIT_NOTE_DETAIL_SUCCESS = 'GET_CREDIT_NOTE_DETAIL_SUCCESS';
export const GET_CREDIT_NOTE_DETAIL_ERROR = 'GET_CREDIT_NOTE_DETAIL_ERROR';

export const UPDATE_CREDIT_NOTE_REQUEST = 'UPDATE_CREDIT_NOTE_REQUEST';
export const UPDATE_CREDIT_NOTE_SUCCESS = 'UPDATE_CREDIT_NOTE_SUCCESS';
export const UPDATE_CREDIT_NOTE_ERROR = 'UPDATE_CREDIT_NOTE_ERROR';

export const DELETE_CREDIT_NOTE_REQUEST = 'DELETE_CREDIT_NOTE_REQUEST';
export const DELETE_CREDIT_NOTE_SUCCESS = 'DELETE_CREDIT_NOTE_SUCCESS';
export const DELETE_CREDIT_NOTE_ERROR = 'DELETE_CREDIT_NOTE_ERROR';

export const COMPLETE_CREDIT_NOTE_REQUEST = 'COMPLETE_CREDIT_NOTE_REQUEST';
export const COMPLETE_CREDIT_NOTE_SUCCESS = 'COMPLETE_CREDIT_NOTE_SUCCESS';
export const COMPLETE_CREDIT_NOTE_ERROR = 'COMPLETE_CREDIT_NOTE_ERROR';

export const createCreditNotes = (data) => dispatch => {
console.log(data);
    return Promise.resolve(dispatch).then(() =>
      dispatch({
        types: [CREATE_CREDITNOTES_REQUEST, CREATE_CREDITNOTES_SUCCESS, CREATE_CREDITENOTES_ERROR],
        callAPI: () => ApiClient.post('payment/CreditNotes', data),
        // callAPI: () => axios.post('http://localhost:5000/api/CreditNotes', data),
        payload: { data },
      }),
    );
  };

  export const fetchCreditNotes = data => dispatch => {
    return Promise.resolve().then(() =>
      dispatch({
        types: [FETCH_CREDITNOTE_REQUEST, FETCH_CREDITNOTE_SUCCESS, FETCH_CREDITNOTE_ERROR],
        callAPI: () => ApiClient.post('payment/CreditNotes/Search', data),
        payload: { data },
      }),
    );
  };

  export const getCreditNoteDetail = id => dispatch => {
    return Promise.resolve().then(() =>
      dispatch({
        types: [GET_CREDIT_NOTE_DETAIL_REQUEST, GET_CREDIT_NOTE_DETAIL_SUCCESS, GET_CREDIT_NOTE_DETAIL_ERROR],
        callAPI: () => ApiClient.get(`payment/CreditNotes/GetDetail/${id}`),
        payload: { data: { id } },
      }),
    );
  };

  export const updateCreditNote = (id, data, formId) => dispatch => {
    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
      dispatch({
        types: [UPDATE_CREDIT_NOTE_REQUEST, UPDATE_CREDIT_NOTE_SUCCESS, UPDATE_CREDIT_NOTE_ERROR],
        callAPI: () => ApiClient.put(`payment/CreditNotes/${id}`, data),
        payload: { data: { ...data, id }, formId },
      }),
    );
  };
  
  export const deleteCreditNote = id => dispatch => {
    return Promise.resolve().then(() =>
      dispatch({
        types: [DELETE_CREDIT_NOTE_REQUEST, DELETE_CREDIT_NOTE_SUCCESS, DELETE_CREDIT_NOTE_ERROR],
        callAPI: () => ApiClient.delete(`payment/CreditNotes/${id}`),
        payload: { data: { id } },
      }),
    );
  };

  export const completeCreditNote = id => dispatch => {
    return Promise.resolve().then(() =>
      dispatch({
        types: [COMPLETE_CREDIT_NOTE_REQUEST, COMPLETE_CREDIT_NOTE_SUCCESS, COMPLETE_CREDIT_NOTE_ERROR],
        callAPI: () => ApiClient.put(`payment/CreditNotes/Complete/${id}`),
        payload: { data: { id } },
      }),
    );
  };

  const initialState = {
    payload: {},
    data: {},
    response: {},
    error: {},
    errorMessage: '',
    successMessage: '',
  };

  export default function reducer(state = initialState, action) {
    const { payload, response, error, successMessage, errorMessage } = action;
    switch (action.type) {
      case FETCH_CREDITNOTE_REQUEST:
      case GET_CREDIT_NOTE_DETAIL_REQUEST:
      case DELETE_CREDIT_NOTE_REQUEST:  
      case COMPLETE_CREDIT_NOTE_REQUEST:
      case UPDATE_CREDIT_NOTE_REQUEST:
      case CREATE_CREDITNOTES_REQUEST:
        return {
          ...state,
          payload,
          response: {},
          error: {},
          successMessage: '',
          errorMessage: '',
        };

      case UPDATE_CREDIT_NOTE_SUCCESS:
      case DELETE_CREDIT_NOTE_SUCCESS:
      case COMPLETE_CREDIT_NOTE_SUCCESS:
      case CREATE_CREDITNOTES_SUCCESS:
        return {
          ...state,
          response,
          successMessage,
        };

        case FETCH_CREDITNOTE_SUCCESS:
          return {
            ...state,
            data: {
              ...state.data,
              items: response.data.data.items,
              pages: response.data.data.pageCount,
            },
            response,
            successMessage,
          };

          case GET_CREDIT_NOTE_DETAIL_SUCCESS:
            return {
              ...state,
              data: {
                ...state.data,
                item: response.data.data,
              },
              response,
              successMessage,
            };

      case GET_CREDIT_NOTE_DETAIL_ERROR:
      case FETCH_CREDITNOTE_ERROR:
      case UPDATE_CREDIT_NOTE_ERROR:
      case DELETE_CREDIT_NOTE_ERROR:
      case COMPLETE_CREDIT_NOTE_ERROR:
      case CREATE_CREDITENOTES_ERROR:
        return {
          ...state,
          payload,
          error,
          errorMessage,
        };
      default:
        return state;
    }
  }

  